import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

const FormularyModal = ({
  open,
  onClose,
  rows = [],
  disableConfirm = false, // optional prop
  loading = false,
  searchLoading = false // Add these props for spinner control
}) => {
  const columns = [
    { field: 'ndc', headerName: 'NDC', width: 150, headerClassName: 'pink-header' },
    { field: 'drgName', headerName: 'DRG NAME', width: 180, headerClassName: 'pink-header',
      renderCell: (params) => (
    <div
      style={{
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.3,
        padding: '10px 2px',
        width: '100%',
      }}
    >
      {params.value}
    </div>
  ),
     },
    { field: 'units', headerName: 'UNITS', width: 50, headerClassName: 'pink-header' },
    { field: 'gpiName', headerName: 'GPI NAME', width: 180, headerClassName: 'pink-header',
      renderCell: (params) => (
    <div
      style={{
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.3,
        padding: '10px 2px',
        width: '100%',
      }}
    >
      {params.value}
    </div>
  ),
     },
    { field: 'awp', headerName: 'AWP', width: 70, headerClassName: 'pink-header' },
    { field: 'wac', headerName: 'WAC', width: 50, headerClassName: 'pink-header' },
    { field: 'discount', headerName: 'DISCOUNT', width: 120, headerClassName: 'pink-header' },
    { field: 'reimburst', headerName: "REIMBURS'T", width: 200, headerClassName: 'pink-header' },
    // { field: 'effDate', headerName: 'EFF DATE', width: 200, headerClassName: 'pink-header' },
    // { field: 'endDate', headerName: 'END DATE', width: 180, headerClassName: 'pink-header' },
    { field: 'formularyStatus', headerName: 'FORMULARY STATUS', width: 180, headerClassName: 'pink-header' },
  ];

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle style={{color: '#ec008c'}}>Pricing Details</DialogTitle>
      <DialogContent>
        {/* Unified spinner overlay for loading and searching */}
        {(loading || searchLoading) && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(255,255,255,0.7)',
            zIndex: 2000,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <div style={{
              border: '6px solid #f3f3f3',
              borderTop: '6px solid #EC088C',
              borderRadius: '50%',
              width: 48,
              height: 48,
              animation: 'spin 1s linear infinite'
            }} />
            <div style={{marginTop: 24, fontSize: '1.2rem', fontWeight: 500, color: '#222'}}>Your request is being processed</div>
            <style>{`@keyframes spin { 0% { transform: rotate(0deg);} 100% {transform: rotate(360deg);} }`}</style>
          </div>
        )}
        {(!rows || rows.length === 0) ? (
          <div>No pricing details available.</div>
        ) : (
          <DataGrid
            rows={rows.map((item, idx) => ({
              id: item.NDC && item.NDC !== "" ? item.NDC + "-" + idx : "row-" + idx,
              ...item,
               ndc: item.NDC,
              drgName: item.DrgName || '',
          units: item.Units || '',
          gpiName: item.GPIName || '',
          awp: item.AWP,
          wac: item.WAC,
          discount: item?.['Discount % (PRR)'],
          reimburst: item?.["Reimburs't $ (PRP)"],
          effDate: item.EFFDate ? new Date(item.EFFDate).toLocaleDateString() : '',
          endDate: item.EndDate ? new Date(item.EndDate).toLocaleDateString() : '',
          formularyStatus: item.FormularyStatus || '',
          details: item.Details || '',
            }))}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[10, 25, 50]}
            disableSelectionOnClick
            hideFooter
            sx={{
            fontSize: '12px',
            fontFamily: 'Segoe UI',
            backgroundColor: 'ec008c',
            '& .pink-header': {
              color: '#fff',
              backgroundColor: '#ec008c',
              fontWeight: 'bold',
               whiteSpace: 'normal !important',
  wordBreak: 'breakWord !important',
  overflowWrap: 'breakWord !important',
  lineHeight: '1.3 !important',
  textAlign: 'center', /* Optional: center the header text */
  padding: '8px 2px !important',
            },
             '& .MuiDataGrid-row:hover': {
              backgroundColor: '#f5f5f5 !important',
              cursor: 'pointer',
            },// Remove blue outline on cell focus
    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
      outline: 'none !important',
      boxShadow: 'none !important',
      backgroundColor: 'none !important',  
     },
     //'& .MuiDataGrid-row:focus-within': {
    //   backgroundColor: '#f5bcbc !important',
    // },
    // Remove blue outline on column header focus
    '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
      outline: 'none !important',
      boxShadow: 'none !important',
    },'& .MuiDataGrid-columnHeaders': {
  backgroundColor: '#ec008c',
  color: '#fff',
  fontWeight: 'bold',
},
'& .MuiDataGrid-columnHeaderTitle': {
  whiteSpace: 'normal',
  wordBreak: 'break-word',
  overflowWrap: 'break-word',
  lineHeight: 1.3,
  textAlign: 'center',
  padding: '8px 2px',
}

          }}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} sx={{
          backgroundColor: '#ec008c',
          color: 'white',
          '&:hover': {
            backgroundColor: '#d5006d',
          },
        }}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default FormularyModal;